// extracted by css-extract-rspack-plugin
export default {"breakeword":"gQCaKWXUnA7cNNgN","filtersRow":"bllF7uKforwIOzgo","eventSelect":"VLVCyfaeI18VKww2","tableWrapper":"K5wEmthRDUsaNBHc"};